export const AI_TUTOR_ROUTES = {
  voiceChat: "/ai-tutor/voice-chat",
};
